module.exports = __webpack_public_path__ + "img/label-light-ru.7e8b1054.svg";